import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

// Connects to data-controller="form--date"
// Displays a DD/MM/YYYY masked text input while keeping a hidden date field
// in YYYY-MM-DD format for Rails form submission.
export default class extends Controller {
  static targets = ["display", "hidden"]

  connect() {
    this.mask = IMask(this.displayTarget, {
      mask: Date,
      pattern: 'd{/}`m{/}`Y',
      blocks: {
        d: { mask: IMask.MaskedRange, from: 1, to: 31, maxLength: 2 },
        m: { mask: IMask.MaskedRange, from: 1, to: 12, maxLength: 2 },
        Y: { mask: IMask.MaskedRange, from: 1900, to: 2100 }
      },
      format: (date) => {
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        return `${day}/${month}/${date.getFullYear()}`
      },
      parse: (str) => {
        const [day, month, year] = str.split('/')
        return new Date(year, month - 1, day)
      }
    })

    if (this.hiddenTarget.value) {
      const [year, month, day] = this.hiddenTarget.value.split('-')
      this.displayTarget.value = `${day}/${month}/${year}`
      this.mask.updateValue()
    }

    this.mask.on('accept', () => this.#syncToHidden())

    this.syncFromHidden = this.#syncFromHidden.bind(this)
    this.hiddenTarget.addEventListener('change', this.syncFromHidden)
    this.hiddenTarget.addEventListener('input', this.syncFromHidden)
  }

  disconnect() {
    this.mask?.destroy()
    this.hiddenTarget.removeEventListener('change', this.syncFromHidden)
    this.hiddenTarget.removeEventListener('input', this.syncFromHidden)
  }

  #syncFromHidden() {
    const v = this.hiddenTarget.value
    if (!v) {
      this.displayTarget.value = ''
      this.mask.updateValue()
      return
    }
    const [year, month, day] = v.split('-')
    this.displayTarget.value = `${day}/${month}/${year}`
    this.mask.updateValue()
  }

  #syncToHidden() {
    const date = this.mask.typedValue
    if (date instanceof Date && !isNaN(date)) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      this.hiddenTarget.value = `${year}-${month}-${day}`
    } else {
      this.hiddenTarget.value = ''
    }
  }
}
